import { useState, useCallback } from "react";

/**
 * Hook to manage error modal state.
 * Provides showError function to display errors and state for the ErrorModal component.
 *
 * Usage:
 *   const { errorMessage, showError, clearError } = useErrorModal();
 *   // Instead of: alert("Error message")
 *   // Use: showError("Error message")
 *
 * @returns {Object} - { errorMessage, showError, clearError }
 */
export function useErrorModal() {
  const [errorMessage, setErrorMessage] = useState(null);

  const showError = useCallback((message) => {
    setErrorMessage(message);
  }, []);

  const clearError = useCallback(() => {
    setErrorMessage(null);
  }, []);

  return {
    errorMessage,
    showError,
    clearError,
  };
}
